import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ActivatedRoute, Router } from '@angular/router';

/* State and Services */
import { AuthService } from 'src/app/core/services/auth.service';

/* Validators */
import { MatchPassword } from 'src/app/shared/validators/match-password';

@Component({
	selector: 'app-reset-password',
	templateUrl: './reset-password.component.html',
	styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
	loading = false;
	token: string = null;
	forgotPasswordForm = new UntypedFormGroup({
		email: new UntypedFormControl('', Validators.required),
	});
	resetPasswordForm = new UntypedFormGroup(
		{
			password: new UntypedFormControl('', Validators.required),
			confirmPassword: new UntypedFormControl('', Validators.required),
		},
		{
			validators: [this.matchPassword.validate],
			updateOn: 'blur',
		},
	);

	constructor(
		private authService: AuthService,
		private matchPassword: MatchPassword,
		private route: ActivatedRoute,
		private router: Router,
		private snackBar: MatSnackBar,
	) {}

	get isPasswordMismatch() {
		return (
			this.resetPasswordForm.get('password')?.touched &&
			this.resetPasswordForm.get('confirmPassword')?.touched &&
			this.resetPasswordForm.errors?.passwordMismatch
		);
	}

	ngOnInit(): void {
		this.route.queryParams.subscribe((params) => {
			// if token, check if expired
			if (params.token) {
				this.authService.validateToken(params.token).subscribe((validToken) => {
					if (validToken) {
						this.token = validToken;
					} else {
						this.token = null;
						this.router.navigate([], { replaceUrl: true });
						this.openSnackBar('Reset password link is expired, request new link.');
					}
				});
			}
		});
	}

	openSnackBar(message: string): void {
		this.snackBar.open(message, 'OK', { duration: 5000 });
	}

	onRequestPassword() {
		this.loading = true;
		this.authService.requestPasswordChange(this.forgotPasswordForm.value.email).subscribe({
			next: () => {
				this.loading = false;
				this.openSnackBar('Please check your email to reset your password.');
			},
			error: () => {
				this.loading = false;
				this.forgotPasswordForm.setErrors({ invalidEmail: true });
			},
		});
	}

	onResetPassword() {
		this.loading = true;
		this.authService.resetPassword(this.resetPasswordForm.value.password, this.token).subscribe({
			next: () => {
				this.loading = false;
				this.openSnackBar('Password successfully updated.');
				this.router.navigateByUrl('/login');
			},
			error: () => {
				this.loading = false;
				this.token = null;
				this.router.navigate([], { replaceUrl: true });
				this.openSnackBar('Reset password link is expired, request new link.');
			},
		});
	}
}
